import React, { Component } from "react";

import { Formik, Form, Field, ErrorMessage } from 'formik';
import moment from "moment/moment";
import {TIME_START_VALUE} from "../../App";

import ReactGA from "react-ga4";

class LuLaBookingInfo extends Component {
  render() {
      const pDate =  !!this.props.pDate ?  moment(this.props.pDate).format('YYYY-MM-DD') : '';
      const pTime = this.props.pTime;

      const options = [...Array(11).keys()].map(x => (
          <option key={x} value={x}>{x}</option>
      ));

    return (
        <div>
            <div className="md3-form-header">
                <div className="md3-form-header-icon">
                    <svg className="icon-svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>
                </div>
                <div className="md3-form-header-text">{pDate}, kl: {pTime}</div>
            </div>

            <div className="md3-card">
                <div className="md3-card-content" style={{padding: '24px'}}>
                <Formik
                    initialValues={{ dateStr: pDate, timeStr: pTime, name: '', email: '',  numberOfKids: 0, numberOfAdults: 0, numberOfPensioners: 0, gdpr: false }}
                    validate={values => {
                        const errors = {};
                        if (!values.dateStr || (values.timeStr === TIME_START_VALUE) ) {
                            errors.dateStr = 'Välj datum och tid';
                        }
                        else if ( !values.name) {
                            errors.name = 'Obligatorisk';
                        }
                        else if (!values.email) {
                            errors.email = 'Obligatorisk';
                        }
                        else if (
                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                        ) {
                            errors.email = 'Felaktig e-postadress';
                        }
                        else if (
                            Number(values.numberOfAdults) + Number(values.numberOfPensioners) < 1
                        ) {
                            errors.numberOfAdults = 'Minst 1 vuxen eller pensionär krävs';
                        }
                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                            // fix dateStr format
                            const myValues = JSON.parse(JSON.stringify(values))
                            const m = moment(myValues["dateStr"]);
                            const wantedDateStr = m.format('YYYYMMDD');
                            myValues["dateStr"] = wantedDateStr;

                            const requestOptions = {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify(myValues)
                            };
                            fetch(process.env.REACT_APP_API + 'bookings', requestOptions)
                                .then(response => response.json())
                                .then(data => {
                                    console.log("resp: " + JSON.stringify(data));

                                    this.props.setBookingId( data["bookingId"] );
                                    setSubmitting(false);
                                    this.props.setPage(3);

                                    // Google Ads conversion tracking
                                    ReactGA.event({
                                        category: "conversion",
                                        action: "Bokning",
                                      });
                                })
                                .catch(err => {
                                    console.error("Booking failed:", err);
                                    setSubmitting(false);
                                    alert("Bokningen misslyckades. Kontrollera din internetanslutning och försök igen.");
                                });

                        }, 500); // to avoid double clicks
                    }}
                >
                    {({ isSubmitting, values, isValid }) => (
                        <Form>
                            <Field type='hidden' name="dateStr"/>
                            <Field type='hidden' name="timeStr"/>
                            <ErrorMessage name="dateStr" component="div" className="md3-field-error"/>

                            <div className="md3-text-field">
                                <Field
                                    name="name"
                                    id="field-name"
                                    className={values.name ? 'has-value' : ''}
                                    aria-label="Namn"
                                />
                                <label htmlFor="field-name">Namn</label>
                                <ErrorMessage name="name" component="div" className="md3-field-error"/>
                            </div>

                            <div className="md3-text-field">
                                <Field
                                    type="email"
                                    name="email"
                                    id="field-email"
                                    className={values.email ? 'has-value' : ''}
                                    aria-label="E-post"
                                />
                                <label htmlFor="field-email">E-post</label>
                                <ErrorMessage name="email" component="div" className="md3-field-error"/>
                            </div>

                            <div className="md3-text-field">
                                <Field
                                    as="select"
                                    name="numberOfKids"
                                    id="field-kids"
                                    className="has-value"
                                    aria-label="Antal barn (2-16 år)"
                                >
                                    {options}
                                </Field>
                                <label htmlFor="field-kids">Antal barn (2–16 år)</label>
                            </div>

                            <div className="md3-text-field">
                                <Field
                                    as="select"
                                    name="numberOfAdults"
                                    id="field-adults"
                                    className="has-value"
                                    aria-label="Antal vuxna"
                                >
                                    {options}
                                </Field>
                                <label htmlFor="field-adults">Antal vuxna</label>
                            </div>

                            <div className="md3-text-field">
                                <Field
                                    as="select"
                                    name="numberOfPensioners"
                                    id="field-pensioners"
                                    className="has-value"
                                    aria-label="Antal pensionärer"
                                >
                                    {options}
                                </Field>
                                <label htmlFor="field-pensioners">Antal pensionärer</label>
                            </div>

                            <ErrorMessage name="numberOfAdults" component="div" className="md3-field-error"/>

                            <div className="md3-checkbox-row">
                                <Field type="checkbox" name="gdpr" id="field-gdpr"/>
                                <label htmlFor="field-gdpr">Jag godkänner att mina uppgifter sparas enligt GDPR.</label>
                            </div>


                            <div className="md3-btn-row" style={{justifyContent: 'space-between'}}>
                                <button type="button" onClick={ () => this.props.setPage(1) } className="md3-btn md3-btn--outlined">
                                    Tillbaka
                                </button>
                                <button type="submit" disabled={isSubmitting || !isValid || !values.gdpr} className="md3-btn md3-btn--filled">
                                    Boka besök
                                </button>
                            </div>

                        </Form>
                    )}
                </Formik>
                </div>
            </div>

        </div>
    );
  }
}

export default LuLaBookingInfo;
